import * as React from "react";
import useMedia from "../../hooks/useMedia/useMedia";
import { Carousel } from "../Carousel/Carousel.web";
import type { Article } from "../data";
import { PromptArtItem } from "./PromptArtItem";
import { useStyles } from "./PromptArtList.web.styles";

export const PromptArtList: React.FC<{ articles: Article[] }> = ({
  articles,
}) => {
  const styles = useStyles();
  const firstRowArticles = articles ? articles.slice(0, 2) : [];
  const secondRowArticles = articles ? articles.slice(2, 5) : [];
  const isDesktop = useMedia({ minWidth: "954px" });

  return (
    <div>
      {isDesktop ? (
        <div className={styles.root}>
          {firstRowArticles.length > 1 && (
            <div className={styles.firstRow}>
              <PromptArtItem
                article={articles[0]}
                className={styles.firstRowItem1}
              />
              <PromptArtItem
                article={articles[1]}
                className={styles.firstRowItem2}
              />
            </div>
          )}

          {secondRowArticles.length > 2 && (
            <div className={styles.secondRow}>
              <PromptArtItem
                article={articles[2]}
                className={styles.secondRowItem}
              />
              <PromptArtItem
                article={articles[3]}
                className={styles.secondRowItem}
              />
              <PromptArtItem
                article={articles[4]}
                className={styles.secondRowItem}
              />
            </div>
          )}
        </div>
      ) : (
        <Carousel id="art">
          {articles.map((article) => (
            <div key={article.title}>
              <div className={styles.carousel}>
                <PromptArtItem className={""} article={article} />
              </div>
            </div>
          ))}
        </Carousel>
      )}
    </div>
  );
};
